import { useState, useEffect, useRef } from "react";

// * Custom hook to track if an element is in view (visible in the viewport)
const useInView = (options) => {
    // State to store if the element is in view or not
    const [isInView, setIsInView] = useState(false); 
    // Ref to attach to the element we want to track
    const ref = useRef(null); 

    useEffect(() => {
        // Save the current ref to avoid issues during cleanup
        const currentRef = ref.current; 

        const observer = new IntersectionObserver(
            ([entry]) => {
                // Set the state to true or false depending on whether the element is in view
                setIsInView(entry.isIntersecting);
            },
            // Pass the options to the observer (like threshold or rootMargin)
            options 
        );

        // If the element (ref) is available, start observing it
        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup function to stop observing when the component is unmounted
        return () => {
            if (currentRef) {
                // Stop observing when component is no longer needed
                observer.unobserve(currentRef); 
            }
        };
        // Re-run the effect only when options change
    }, [options]); 

    // Return the ref and the in-view state
    return [ref, isInView];
};

export default useInView;
